import { render, staticRenderFns } from "./TableBudgetHealth.vue?vue&type=template&id=33b8bedb&scoped=true"
import script from "./TableBudgetHealth.vue?vue&type=script&lang=js"
export * from "./TableBudgetHealth.vue?vue&type=script&lang=js"
import style0 from "./TableBudgetHealth.vue?vue&type=style&index=0&id=33b8bedb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b8bedb",
  null
  
)

export default component.exports